import { motion } from 'framer-motion';

const TrustSection = () => {
  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-3 h-3 flex items-center justify-center rotate-45 bg-[#1A2F4A]"></div>
            <p className="text-sm uppercase tracking-wider text-[#1A2F4A] font-semibold">
              TRUSTED LOCALLY
            </p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2F4A]">
            Why Choose Wharfedale?
          </h2>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-3xl p-10 text-center"
          >
            <div className="w-20 h-20 flex items-center justify-center bg-[#1A2F4A] rounded-full mx-auto mb-6">
              <span className="text-3xl font-bold text-white">15+</span>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2F4A] mb-4">Years of Experience</h3>
            <p className="text-gray-600 leading-relaxed">
              Proudly serving the local community since 2010 with expert plumbing and heating solutions.
            </p>
          </motion.div>

          {/* Feature 2 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-3xl p-10 text-center"
          >
            <div className="w-20 h-20 flex items-center justify-center bg-[#1A2F4A] rounded-full mx-auto mb-6">
              <i className="ri-map-pin-line text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2F4A] mb-4">Local to Otley</h3>
            <p className="text-gray-600 leading-relaxed">
              Based in Otley with quick response times throughout Wharfedale and surrounding areas.
            </p>
          </motion.div>

          {/* Feature 3 - Photo Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="relative rounded-3xl overflow-hidden h-full min-h-[300px]"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/ade6d188667947fe938f329e95932996.jpg"
              alt="Professional engineer"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A2F4A]/90 via-[#1A2F4A]/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <h3 className="text-2xl font-bold mb-2">Fully Insured & Certified</h3>
              <p className="text-white/90">Gas Safe & Part P Registered</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;